(function ($) {

    var all_maps = {};
    var all_markers = {};
    var all_bounds = {};
    var marker_status = {};
    var all_infowindows = {};

    $(document).ready(function () {
        changeMode();
        var map_position = $('#map_canvas').offset().top - $('#map_canvas').height();
        var window_height = $(window).height();
        var map_processed = false;

        var map_section = document.querySelector('.map_section');
        observer = new IntersectionObserver(function(entry, observer){
            if(entry[0].intersectionRatio > 0){
                initMap();
                observer.unobserve(map_section);
            }
        });
        observer.observe(map_section);

    });


    function changeMode() {
        var button_itinerary_mode = $('.itinerary_mode .icons a');
        button_itinerary_mode.on('click', function(){
            if(!$(this).hasClass('current')){
                $(this).addClass('current');
                $(this).siblings().removeClass('current');
            }
        });
    }

    function detectMode() {

        var initeraryModeSelected = $('.itinerary_mode .icons a.current');

        return initeraryModeSelected.attr('data-travelmode');

    }

    function initMap() {

        $('#map_canvas').each(function () {
            var container = $(this),
                outer_container = container.parent(),
                section = container.closest('.section'),
                div_id = container.attr('id');
            initialize_map_multi(div_id);
            outer_container.find('.category a').click(function () {
                var category = $(this).data('category');
                var category_id = $(this).data('category-id');
                var category_title = $(this).text();

                if ($(this).parent().hasClass('active')) {
                    toggle_category('', div_id);
                    $(this).parent().removeClass('active');
                    $(this).find('.icon').attr('aria-checked',false);
                } else {
                    toggle_category(category, div_id);
                    $('.category a').parent().removeClass('active');
                    $(this).parent().addClass('active');
                    $(this).find('.icon').attr('aria-checked',true);
                }
                $(this).parent().siblings().find('.icon').attr('aria-checked',false);
                showPOIonSurroundingsPage(category_id, category_title);
            });
            if(is_mobile){
                outer_container.find('.category-mobile').on('change', function(){
                    var option_selected = $(this).find('option:selected');
                    var category = option_selected.data('category');
                    var category_id = option_selected.val();
                    var category_title = $(this).text();
                    toggle_category(category, div_id);
                    showPOIonSurroundingsPage(category_id, category_title);
                });
            }


            if (outer_container.hasClass('show_pois_at_load')) {
                toggle_category('zzz_all', div_id);
            }
            show_markers('map_canvas');
        });

        mapInfoBox();
        getDirectionsButton();

        // $('#map_overlay .category li:first-child a').trigger("click");

        if ($('#map_directions').size() > 0) {
            $('#itinerarySubmit').on('click', function () {
                var start = $('input#itineraryFrom').val();
                calcRoute(start, detectMode());
            });
        }
    }

    function initialize_map_multi(div_id) {
        if (typeof (all_bounds[div_id]) === "undefined") all_bounds[div_id] = new google.maps.LatLngBounds();
        map_zoom = (typeof map_zoom === 'undefined') ? 14 : map_zoom;

        all_maps[div_id] = new google.maps.Map(document.getElementById(div_id), {
            // scroll wheel
            scrollwheel: false,
            //zoom
            zoom: map_zoom,
            center: new google.maps.LatLng(hotel_gps_coordinates.latitude, hotel_gps_coordinates.longitude),
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            //map type
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT,
                style: google.maps.MapTypeControlStyle.DEFAULT
            },
            // default pan control
            panControl: false,
            scaleControl: false,
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_LEFT
            }
        });

        var styles = styleResolved;
        create_markers(div_id);
        show_markers(div_id);

        all_maps[div_id].setOptions({styles: styles});
        all_maps[div_id].setOptions({mapTypeId: map_type});


        directionsService = new google.maps.DirectionsService(),
        directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: false,
            markerOptions: {zIndex: 10}
        });
    }

    function create_markers(div_id) {
        all_markers[div_id] = {};
        for (var i = 0; i < map_data.markers.length; i++) {
            var el = map_data.markers[i];
            var is_hotel = el.slug === 'hotel';
            var image_url = map_data.icon;
            var image_size = new google.maps.Size(marker_sizes.poi.image_size[0],marker_sizes.poi.image_size[1]);
            var anchor = new google.maps.Point(marker_sizes.poi.anchor[0],marker_sizes.poi.anchor[1]);
            if (is_hotel) {
                image_url = map_data.icon_hotel;
                image_size = new google.maps.Size(marker_sizes.hotel.image_size[0],marker_sizes.hotel.image_size[1]);
                anchor = new google.maps.Point(marker_sizes.hotel.anchor[0],marker_sizes.hotel.anchor[1]);
            }
            var image = {
                url: image_url,
                size: image_size,
                anchor: anchor
            };
            all_markers[div_id][el.slug] = new google.maps.Marker({
                position: new google.maps.LatLng(el.latitude, el.longitude),
                map: null,
                icon: image
            });
            var callback = (function (div_id, marker_id) {
                return function () {
                    show_marker_infowindow(marker_id, div_id);
                }
            })(div_id, el.slug);
            all_markers[div_id][el.slug].addListener('click', callback);
        }
    }

    function show_markers(div_id, only_fitbounds) {
        var visible_counter = 0, center;
        if (typeof only_fitbounds === 'undefined') {
            only_fitbounds = false;
        }
        all_bounds[div_id] = new google.maps.LatLngBounds();
        if (typeof marker_status[div_id] == 'undefined') {
            marker_status[div_id] = map_config[div_id].visible_markers;
        }
        for (var i = 0; i < map_data.markers.length; i++) {
            var el = map_data.markers[i];
            if (marker_status[div_id].indexOf(el.slug) !== -1) {
                if (!only_fitbounds) {
                    all_markers[div_id][el.slug].setMap(all_maps[div_id]);
                }
                all_bounds[div_id].extend(all_markers[div_id][el.slug].getPosition());
                if (visible_counter === 0) {
                    center = all_markers[div_id][el.slug].getPosition();
                }
                visible_counter++;
            } else {
                if (!only_fitbounds) {
                    all_markers[div_id][el.slug].setMap(null);
                }
            }
        }
        if (visible_counter === 1) {
            all_maps[div_id].setCenter(center);
            all_maps[div_id].setZoom(map_config[div_id].default_zoom);
            google.maps.event.trigger(all_maps[div_id], 'resize');
        } else {
            all_maps[div_id].fitBounds(all_bounds[div_id]);
        }
    }

    /**
     * @param marker_id
     * @param div_id
     * @return boolean - true if marker was made visible, false if it was hidden
     */
    function toggle_marker_visibility(marker_id, div_id) {
        if (typeof div_id === 'undefined') {
            div_id = 'map_canvas';
        }
        if (marker_status[div_id].indexOf(marker_id) === -1) {
            marker_status[div_id].push(marker_id);
            show_markers(div_id);
            return true;
        } else {
            marker_status[div_id] = marker_status[div_id].filter(function (item) {
                return item !== marker_id;
            });
            show_markers(div_id);
            return false;
        }
    }

    function toggle_category(category, div_id) {
        marker_status[div_id] = ['hotel'];
        if (typeof map_data.markers_by_category[category] !== 'undefined') {
            for (var i = 0; i < map_data.markers_by_category[category].length; i++) {
                marker_status[div_id].push(map_data.markers_by_category[category][i]);
            }
        }
        show_markers(div_id);
    }

    function get_marker_data_by_id(marker_id) {
        for (var i = 0; i < map_data.markers.length; i++) {
            var el = map_data.markers[i];
            if (el.slug === marker_id) {
                return el;
            }
        }
    }

    function show_marker_infowindow(marker_id, div_id, visible) {

        var marker = get_marker_data_by_id(marker_id);
        if (typeof all_infowindows[div_id] === 'undefined') {
            all_infowindows[div_id] = new google.maps.InfoWindow({
                content: marker.infowindow
            });
        } else {
            all_infowindows[div_id].setContent(marker.infowindow);
        }
        all_infowindows[div_id].open(all_maps[div_id], all_markers[div_id][marker_id]);
    }

    function calcRoute(start, mode) {
        mode = mode || (mapConfig.mode === 'car' ? 'DRIVING' : 'WALKING');
        var end = hotel_gps_coordinates.latitude + ',' + hotel_gps_coordinates.longitude,
            request = {
                origin: start,
                destination: end,
                travelMode: google.maps.DirectionsTravelMode[mode]
            }, itineraryTitle;

        if ($.trim(start) === '') {
            alert('insert the destination');
            return;
        }

        directionsService.route(request, function (response, status) {
            if (status === google.maps.DirectionsStatus.OK) {
                itineraryTitle = $('#itinerary_container .title span').html() + ' ' +
                    //itineraryTitle=$('#itinerarySubmit').html()+' '+
                    //$('#itineraryMode').attr('data-vers')+' '+
                    ':';
                if ($('.itineraryPanelWrapper').length === 0) {
                    $('#map_directions_content').append(
                        $('<div/>', {'class': 'itineraryPanelWrapper'})
                            .append($('<div/>', {'class': 'title'}))
                            .append($('<div/>', {id: 'itineraryPanel'}))
                    );
                }
                //	$('.itineraryPanelWrapper .title').html(itineraryTitle);
                directionsDisplay.setMap(all_maps['map_canvas']);
                directionsDisplay.setPanel(document.getElementById('itineraryPanel'));
                directionsDisplay.setDirections(response);

                if ($('#map_directions').size() > 0) {

                    $('#map_directions').fadeIn(function () {
                        $('.close').click(function () {
                            $('#map_directions').fadeOut(function () {
                                $('#map_canvas').each(function () {
                                    var container = $(this),
                                        outer_container = container.parent();
                                    if (outer_container.hasClass('show_pois_at_load')) {
                                        directionsDisplay.setMap(null);
                                        all_maps['map_canvas'].fitBounds(all_bounds['map_canvas']);
                                    } else {
                                        var hotel = new google.maps.LatLng(hotel_gps_coordinates.latitude, hotel_gps_coordinates.longitude);
                                        directionsDisplay.setMap(null);
                                        all_maps['map_canvas'].setZoom(map_zoom);
                                        all_maps['map_canvas'].setCenter(hotel);
                                    }
                                });
                            });
                        });
                    });
                }
            } else {
                alert('ERROR');
            }
        });
    };

    function showPOIonSurroundingsPage(category, category_title) {
        var title = category_title;
        var filter = '.filter_' + category;
        var pois_wrap = $('.section.filterable_by_map');
        var pois = pois_wrap.find('.item_wrap');
        if (!pois_wrap.length || !pois.length) {
            return;
        }
        pois_wrap.find('.the_title').text(title);
        if (filter === '.filter_zzz_all') {
            pois.css('display', 'block');
        } else {
            pois.css('display', 'none');
            pois_wrap.find('.item_wrap' + filter).css('display', 'block');
        }
    }

    function mapInfoBox() {
        var titles = $('#map_info .item .title');

        $('#map_info .item:not(.open)').find('.hidden_content').find('a, input').attr('tabindex',-1);

        titles.click(function () {
            if (titles.length === 1) {
                return;
            }
            var link = $(this),
                wrap = link.parent(),
                description = wrap.find('.collapsibleContent'),
                inner_wrap = description.find('> div'),
                height = inner_wrap.outerHeight(true);

            $('#map_info .item .collapsibleContent').animate({height: 0});
            $('#map_info .item').not(link.closest('.item')).removeClass('open');
            if (wrap.hasClass('open')) {
                description.stop().animate({height: 0});
                wrap.removeClass('open');
            } else {
                $(description).stop().animate({height: 0});
                $(wrap).removeClass('open');

                description.stop().animate({height: height});
                wrap.addClass('open');

                wrap.find('.hidden_content').find('a, input').removeAttr('tabindex');
                wrap.siblings().find('.hidden_content').find('a, input').attr('tabindex',-1)


                if (wrap.hasClass('item_points') && !$('#map_filters .category li:last-child').hasClass('active')) {
                    $('#map_filters .category li:last-child a').trigger("click");
                } else if ($('#map_filters .category li:last-child').hasClass('active')) {
                    $('#map_filters .category li:last-child a').trigger("click");
                }

            }

        });
        var lastFilter = $('#map_filters .category li:last-child');
        if (lastFilter.hasClass('active')) {
            lastFilter.removeClass('active');
            lastFilter.find('a').trigger("click");
        }
    }

    function setTabIndex(selector,tabIndex = 0){
        if(selector !== undefined){
            selector.each(function(){
                if($(this).hasClass('open')){
                    $(this).find('.hidden_content').find('a, input').removeAttr('tabindex');
                } else {
                    $(this).find('.hidden_content').find('a, input').attr('tabindex',tabIndex);
                }
            });
        }
    }

    function getDirectionsButton() {
        $(document).on('click', '#map_canvas .get_directions a', function () {
            var coordinates = $(this).data('coordinates');
            $('#itineraryFrom').val(coordinates);
            $('#map_info .get_directions .title').trigger('click');
            $('#itinerarySubmit').trigger('click');
        });
    }

}(jQuery));



